import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "group_create",
  "use": "group_create-usage",
  "viewBox": "0 0 13 13",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 13 13\" id=\"group_create\"><path d=\"M1.333 1.333h2.223V0H0v3.556h1.333zM8.89 0v1.333h2.222v2.223h1.333V0zm2.222 11.111H8.89v1.333h3.555V8.89h-1.333zM2.667 9.778h7.11V2.667h-7.11zM7.11 3.556H8.89v1.777H7.11zm0 3.555H8.89V8.89H7.11zM3.556 3.556h1.777v1.777H3.556zm0 3.555h1.777V8.89H3.556zM1.333 8.89H0v3.555h3.556v-1.333H1.333z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol